var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64645 5.44625C1.84171 5.25099 2.15829 5.25099 2.35355 5.44625L8 11.0927L13.6464 5.44625C13.8417 5.25099 14.1583 5.25099 14.3536 5.44625C14.5488 5.64151 14.5488 5.9581 14.3536 6.15336L8.35355 12.1534C8.15829 12.3486 7.84171 12.3486 7.64645 12.1534L1.64645 6.15336C1.45118 5.9581 1.45118 5.64151 1.64645 5.44625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.90dfd0e11043e48b240aa2c4a3546cfd.svg";
export { ForwardRef as ReactComponent };